import * as React from 'react';
import { Dimmer, Loader } from 'semantic-ui-react';


const CustomLoader = props => {
  const { isLoading } = props;

  return (
    <Dimmer active={isLoading}>
      <Loader>Aguarde...</Loader>
    </Dimmer>
  )
}

export default CustomLoader;